module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_26.8aa712c4.jpg";